import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { getDetailSegment, getHeaderTUDF } from "../../../utils/buro";
import { Button } from "../layer/wrapper";
import { format, differenceInDays } from "date-fns";
import _ from "lodash";
import FileSaver from "file-saver";
import {
  reinstallments,
  calcuratorInterestTwo,
} from "../../../utils/reinstallments";
import { API } from "aws-amplify";
import { getFilterLoanBuro } from "../BuroMainTwo";
import iconv from "iconv-lite";
import { calReportAging } from "../../../utils/calReportAging";
import Swal from "sweetalert2";
import { excludeBuroBan, fetchBuroBanIds } from "../buroBan";

// const iconv = require("iconv-lite");

function ExportBuro({
  loan = [],
  buroDate = new Date(),
  interest,
  loanLastPaymentDone = [],
}) {
  const [loadingExport, setLoadingExport] = useState(false);
  const [error, setError] = useState(null);
  const [dataCsv, setDataCsv] = useState("");
  const [countExport, setCountExport] = useState(0);

  useEffect(async () => {
    if (dataCsv) {
      console.log("buroDate", buroDate)
      const filename = `TUCRS-MHS-${format(new Date(buroDate), "yyyy-MM")}.txt`;
      const buffer = iconv.encode(dataCsv, "874");
      const buroBlob = new Blob([buffer]);
      FileSaver.saveAs(buroBlob, filename);
    }
  }, [dataCsv]);

  const onClickExportBuro = async () => {
    try {
      setLoadingExport(true);

      const buroBanIds = await fetchBuroBanIds();

      let { dataPrinciple: newLoan } = calReportAging(loan, buroDate);

      let filterLoan = _.cloneDeep(newLoan).filter((itemLoan) => {
        const diffDefaultDate = differenceInDays(
          new Date(buroDate),
          new Date(itemLoan.overdue_date)
        );
        return diffDefaultDate <= 1915; //มากกว่า 5ปี 90วัน
      });

      filterLoan = excludeBuroBan(
        getFilterLoanBuro(filterLoan, buroDate, interest),
        buroBanIds
      );

      let dataExport = _.cloneDeep(
        excludeBuroBan(
          [...filterLoan, ...loanLastPaymentDone],
          buroBanIds
        ).filter((loanItem) => String(loanItem?.loan_kbank_id) !== "400139072")
      );
      

      // console.log(
      //   "1",
      //   getDetailSegment({
      //     dataExport,
      //     currentDate: new Date(buroDate),
      //     showConsole: true,
      //     showLog: true,
      //   })
      // );

      console.log("buroDate", buroDate);

      setCountExport(filterLoan.length);
      setDataCsv(
        `${getHeaderTUDF({
          env: "production",
          dataExport,
          currentDate: buroDate,
        })}\n${getDetailSegment({
          dataExport,
          currentDate: new Date(buroDate),
          // showConsole: true,
          // showLog: true,
        })}TRLR`
      );
    } catch (error) {
      console.log("error", error)
      Swal.fire("Export Buro ไม่สำเร็จ", error?.message || "", "error");
    } finally {
      setLoadingExport(false);
    }
  };

  return (
    <div>
      <Button
        onClick={onClickExportBuro}
        disabled={loadingExport || loan?.length === 0}
        loading={loadingExport}
      >
        {countExport > 0 &&
          `${countExport}${
            loanLastPaymentDone && ` + ${loanLastPaymentDone.length}`
          }`}{" "}
        Export Buro
      </Button>
      <CSVLink
        id="csv-link"
        hidden
        data={dataCsv}
        filename={`TUCRS-MHS-${format(new Date(buroDate), "yyyy-MM")}.txt`}
      />
    </div>
  );
}

export default ExportBuro;
